<template>
  <section class="grid gap-16">
    <NativeVideo
      :id="impactVideoId(impact)"
      :sources="sourcesFor(impact)"
      :poster="intro.poster"
      :title="i18n(intro.title)"
      @play="handlePlay()"
    />
    <div class="grid gap-8">
      <h2 class="raw-heading-2">{{ i18n(intro.title) }}</h2>
      <p class="text-[--raw-verydarkgrey]">
        {{ i18n(intro.description) }}
      </p>
    </div>

    <!-- The journey's metal; the metal sheet carries the same row. -->
    <JourneyEntry v-if="journey" :journey zone="impact-intro" />
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import NativeVideo from '~/scopes/campaign/components/UI/NativeVideo.vue'
import JourneyEntry from '~/scopes/campaign/components/journey/JourneyEntry.vue'
import { useVideoSources } from '~/scopes/campaign/composables/useVideoSources'
import type { ImpactType } from '~/scopes/campaign/data/articles/data'
import { IMPACT_INTROS } from '~/scopes/campaign/data/impact-intros'
import { journeyFor } from '~/scopes/campaign/data/journeys/data'
import { impactVideoId } from '~/scopes/campaign/data/videos'

const i18n = useI18n()
const { trackClick } = useTracking()
const { sourcesFor } = useVideoSources()
const props = defineProps<{ impact: ImpactType }>()

const intro = computed(() => IMPACT_INTROS[props.impact])
const journey = computed(() => journeyFor(props.impact))

function handlePlay() {
  trackClick({ zone: 'impact-intro', name: props.impact })
}
</script>
